import { start as startRemoteConfig } from "./remote-config";
import { start as startFilters } from "./filters";
export function start() {
    startRemoteConfig();
    startFilters();
}
